import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const BusinessName = ({ ...props }: InputComponentProps) => {
  const validate = ({ value }) => {
    if (value.length < 1) return 'Please enter a business name';
    return true;
  };

  return (
    <ValidatingInput
      label="Business name"
      name="businessName"
      placeholder="Business name"
      validate={validate}
      {...props}
    />
  );
};
